import paayService from '@/services/paay-three-ds';
import cardinalService from '@/services/cardinal-three-ds';

/** Services are factory functions that expose submitTdsTransaction method */
const providerMap = {
  Paay: paayService,
  Cardinal: cardinalService
};

const _getTdsProviderService = providerName => providerMap[providerName] ?? null;

const getTdsProvider = (providers) => {
  const tdsProviderDetails = Object.values(providers).find(value => value.threeDsRequired);

  const result = {
    tdsProviderService: _getTdsProviderService(tdsProviderDetails?.threeDsProvider),
    ...tdsProviderDetails
  };

  return result;
};

export default getTdsProvider;
